import { render, staticRenderFns } from "./playboxscore.vue?vue&type=template&id=73391ac0"
import script from "./playboxscore.vue?vue&type=script&lang=js"
export * from "./playboxscore.vue?vue&type=script&lang=js"
import style0 from "./playboxscore.vue?vue&type=style&index=0&id=73391ac0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports